import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteBrandingSetups } from '@api/managePlatformBranding';

import { ESnackbarTypes } from '@enums/common';

import { BRANDING_SETUPS, DELETE_BRANDING_SETUP } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IRemoveBrandingSetupsReturn {
	handleDeleteBrandingSetups: (setupIds: string[]) => void;
	isLoadingDeleteBrandingSetups: boolean;
}

export const useMutateRemoveBrandingSetups = (
	onSettledCallbacks?: Array<() => void>,
): IRemoveBrandingSetupsReturn => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleDeleteBrandingSetups,
		isLoading: isLoadingDeleteBrandingSetups,
	} = useMutation<Array<string>>({
		mutationKey: [DELETE_BRANDING_SETUP],
		mutationFn: deleteBrandingSetups,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.removedBrandingSetups,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([BRANDING_SETUPS]);
		},
	});

	return {
		handleDeleteBrandingSetups,
		isLoadingDeleteBrandingSetups,
	};
};
